export enum ErknmAnalyticsColumnValueTypeEnum {
  WIP = 'WIP',
  NUMBER = 'NUMBER',
  CURRENCY = 'CURRENCY',
  FLOAT = 'FLOAT',
}
